var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "font-picker"
  }, [_c('font-select', {
    attrs: {
      "value": _vm.selectedValue,
      "custom-font": _vm.customFont
    },
    on: {
      "select": _vm.onSelect,
      "custom-font": _vm.onCustomFont
    }
  }), _vm._l(_vm.languageOverrides, function (override, index) {
    return _c('div', {
      key: "lang-font-".concat(index),
      staticClass: "lang-font-row mb-3 mt-3"
    }, [_c('div', {
      staticClass: "d-flex align-start"
    }, [_c('v-select', {
      staticClass: "language-select mr-3",
      attrs: {
        "value": override.lang,
        "items": _vm.availableOverrideLanguages(override.lang),
        "item-text": "text",
        "item-value": "value",
        "solo": "",
        "hide-details": ""
      },
      on: {
        "change": function change($event) {
          return _vm.updateOverrideLang(index, $event);
        }
      }
    }), _c('font-select', {
      staticClass: "mr-3",
      attrs: {
        "value": override.fontFamily,
        "custom-font": _vm.languageCustomFonts[override.lang]
      },
      on: {
        "select": function select($event) {
          return _vm.onLanguageSelect(override.lang, $event);
        },
        "custom-font": function customFont($event) {
          return _vm.onLanguageCustomFont(override.lang, $event);
        }
      }
    }), _c('v-btn', {
      staticClass: "mt-2",
      attrs: {
        "icon": ""
      },
      on: {
        "click": function click($event) {
          return _vm.removeOverride(index);
        }
      }
    }, [_c('v-icon', [_vm._v("$remove")])], 1)], 1)]);
  }), _c('v-btn', {
    staticClass: "ml-0 mt-2",
    attrs: {
      "text": "",
      "color": "primary",
      "disabled": _vm.addableLanguages.length === 0
    },
    on: {
      "click": _vm.addOverride
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" " + _vm._s(_vm.$t('design_font_language_add')) + " ")], 1)], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }